export const GET_STORE_ORDERS_START = 'GET_STORE_ORDERS_START';
export const GET_STORE_ORDERS_SUCCESS = 'GET_STORE_ORDERS_SUCCESS';
export const GET_STORE_ORDERS_FAILED = 'GET_STORE_ORDERS_FAILED';

export const RESEND_ORDER_EMAIL_START = 'RESEND_ORDER_EMAIL_START';
export const RESEND_ORDER_EMAIL_SUCCESS = 'RESEND_ORDER_EMAIL_SUCCESS';
export const RESEND_ORDER_EMAIL_FAILED = 'RESEND_ORDER_EMAIL_FAILED';

export const UPDATE_STORE_ORDER_START = 'UPDATE_STORE_ORDER_START';
export const UPDATE_STORE_ORDER_SUCCESS = 'UPDATE_STORE_ORDER_SUCCESS';
export const UPDATE_STORE_ORDER_FAILED = 'UPDATE_STORE_ORDER_FAILED';

export const SAVE_STORE_ORDER_COMMENT_START = 'SAVE_STORE_ORDER_COMMENT_START';
export const SAVE_STORE_ORDER_COMMENT_SUCCESS = 'SAVE_STORE_ORDER_COMMENT_SUCCESS';
export const SAVE_STORE_ORDER_COMMENT_FAILED = 'SAVE_STORE_ORDER_COMMENT_FAILED';

export const HOLD_ORDERS_START = 'HOLD_ORDERS_START';
export const HOLD_ORDERS_SUCCESS = 'HOLD_ORDERS_SUCCESS';
export const HOLD_ORDERS_FAILED = 'HOLD_ORDERS_FAILED';

export const UNHOLD_ORDERS_START = 'UNHOLD_ORDERS_START';
export const UNHOLD_ORDERS_SUCCESS = 'UNHOLD_ORDERS_SUCCESS';
export const UNHOLD_ORDERS_FAILED = 'UNHOLD_ORDERS_FAILED';

export const UPDATE_MULTIPLE_ORDERS_POSTED_STATUS_START = 'UPDATE_MULTIPLE_ORDERS_POSTED_STATUS_START';
export const UPDATE_MULTIPLE_ORDERS_POSTED_STATUS_SUCCESS = 'UPDATE_MULTIPLE_ORDERS_POSTED_STATUS_SUCCESS';
export const UPDATE_MULTIPLE_ORDERS_POSTED_STATUS_FAILED = 'UPDATE_MULTIPLE_ORDERS_POSTED_STATUS_FAILED';

export const GENERATE_ORDERS_INVOICE_PDF_START = 'GENERATE_ORDERS_INVOICE_PDF_START';
export const GENERATE_ORDERS_INVOICE_PDF_SUCCESS = 'GENERATE_ORDERS_INVOICE_PDF_SUCCESS';
export const GENERATE_ORDERS_INVOICE_PDF_FAILED = 'GENERATE_ORDERS_INVOICE_PDF_FAILED';

export const GET_STORE_ORDER_ITEMS_DETAILS_START = 'GET_STORE_ORDER_ITEMS_DETAILS_START';
export const GET_STORE_ORDER_ITEMS_DETAILS_SUCCESS = 'GET_STORE_ORDER_ITEMS_DETAILS_SUCCESS';
export const GET_STORE_ORDER_ITEMS_DETAILS_FAILED = 'GET_STORE_ORDER_ITEMS_DETAILS_FAILED';

export const GET_INVOICE_ORDER_DATA_START = 'GET_INVOICE_ORDER_DATA_START';
export const GET_INVOICE_ORDER_DATA_SUCCESS = 'GET_INVOICE_ORDER_DATA_SUCCESS';
export const GET_INVOICE_ORDER_DATA_FAILED = 'GET_INVOICE_ORDER_DATA_FAILED';

export const GET_ORDER_PRODUCTS_BY_SKUS_START = 'GET_ORDER_PRODUCTS_BY_SKUS_START';
export const GET_ORDER_PRODUCTS_BY_SKUS_SUCCESS = 'GET_ORDER_PRODUCTS_BY_SKUS_SUCCESS';
export const GET_ORDER_PRODUCTS_BY_SKUS_FAILED = 'GET_ORDER_PRODUCTS_BY_SKUS_FAILED';

export const REFUND_ORDER_START = 'REFUND_ORDER_START';
export const REFUND_ORDER_SUCCESS = 'REFUND_ORDER_SUCCESS';
export const REFUND_ORDER_FAILED = 'REFUND_ORDER_FAILED';

export const SHIP_ORDER_START = 'SHIP_ORDER_START';
export const SHIP_ORDER_SUCCESS = 'SHIP_ORDER_SUCCESS';
export const SHIP_ORDER_FAILED = 'SHIP_ORDER_FAILED';

export const GET_NEXTECH_DUPLICATED_CUSTOMERS_START = 'GET_NEXTECH_DUPLICATED_CUSTOMERS_START';
export const GET_NEXTECH_DUPLICATED_CUSTOMERS_SUCCESS = 'GET_NEXTECH_DUPLICATED_CUSTOMERS_SUCCESS';
export const GET_NEXTECH_DUPLICATED_CUSTOMERS_FAILED = 'GET_NEXTECH_DUPLICATED_CUSTOMERS_FAILED';

export const GET_MODMED_DUPLICATED_CUSTOMERS_START = 'GET_MODMED_DUPLICATED_CUSTOMERS_START';
export const GET_MODMED_DUPLICATED_CUSTOMERS_SUCCESS = 'GET_MODMED_DUPLICATED_CUSTOMERS_SUCCESS';
export const GET_MODMED_DUPLICATED_CUSTOMERS_FAILED = 'GET_MODMED_DUPLICATED_CUSTOMERS_FAILED';

export const UPDATE_NEXTECH_STATUS_START = 'UPDATE_NEXTECH_STATUS_START';
export const UPDATE_NEXTECH_STATUS_SUCCESS = 'UPDATE_NEXTECH_STATUS_SUCCESS';
export const UPDATE_NEXTECH_STATUS_FAILED = 'UPDATE_NEXTECH_STATUS_FAILED';

export const GET_INVOICE_COMMENTS_START = 'GET_INVOICE_COMMENTS_START';
export const GET_INVOICE_COMMENTS_SUCCESS = 'GET_INVOICE_COMMENTS_SUCCESS';
export const GET_INVOICE_COMMENTS_FAILED = 'GET_INVOICE_COMMENTS_FAILED';

export const GET_SHIPPING_COMMENTS_START = 'GET_SHIPPING_COMMENTS_START';
export const GET_SHIPPING_COMMENTS_SUCCESS = 'GET_SHIPPING_COMMENTS_SUCCESS';
export const GET_SHIPPING_COMMENTS_FAILED = 'GET_SHIPPING_COMMENTS_FAILED';

export const GET_CREDIT_MEMO_COMMENTS_START = 'GET_CREDIT_MEMO_COMMENTS_START';
export const GET_CREDIT_MEMO_COMMENTS_SUCCESS = 'GET_CREDIT_MEMO_COMMENTS_SUCCESS';
export const GET_CREDIT_MEMO_COMMENTS_FAILED = 'GET_CREDIT_MEMO_COMMENTS_FAILED';

export const GET_ORDERS_SHIPMENTS_START = 'GET_ORDERS_SHIPMENTS_START';
export const GET_ORDERS_SHIPMENTS_SUCCESS = 'GET_ORDERS_SHIPMENTS_SUCCESS';
export const GET_ORDERS_SHIPMENTS_FAILED = 'GET_ORDERS_SHIPMENTS_FAILED';

export const GET_PEYMENT_METHOD_NAME_START = 'GET_PEYMENT_METHOD_NAME_START';
export const GET_PEYMENT_METHOD_NAME_SUCCESS = 'GET_PEYMENT_METHOD_NAME_SUCCESS';
export const GET_PEYMENT_METHOD_NAME_FAILED = 'GET_PEYMENT_METHOD_NAME_FAILED';


export const getStoreOrdersStart = () => ({
  type: GET_STORE_ORDERS_START
});

export const getStoreOrdersSuccess = (data) => ({
  type: GET_STORE_ORDERS_SUCCESS,
  data
});

export const getStoreOrdersFailed = (error) => ({
  type: GET_STORE_ORDERS_FAILED,
  error
});

export const resendOrderEmailStart = () => ({
  type: RESEND_ORDER_EMAIL_START
});

export const resendOrderEmailSuccess = () => ({
  type: RESEND_ORDER_EMAIL_SUCCESS
});

export const resendOrderEmailFailed = (error) => ({
  type: RESEND_ORDER_EMAIL_FAILED,
  error
});

export const updateStoreOrderStart = () => ({
  type: UPDATE_STORE_ORDER_START
});

export const updateStoreOrderSuccess = (data) => ({
  type: UPDATE_STORE_ORDER_SUCCESS,
  data
});

export const updateStoreOrderFailed = (error) => ({
  type: UPDATE_STORE_ORDER_FAILED,
  error
});

export const saveStoreOrderCommentStart = () => ({
  type: SAVE_STORE_ORDER_COMMENT_START
});

export const saveStoreOrderCommentSuccess = (orderId, comment) => ({
  type: SAVE_STORE_ORDER_COMMENT_SUCCESS,
  orderId,
  comment
});

export const saveStoreOrderCommentFailed = (error) => ({
  type: SAVE_STORE_ORDER_COMMENT_FAILED,
  error
});

export const holdOrdersStart = () => ({
  type: HOLD_ORDERS_START
});

export const holdOrdersSuccess = (orderIds) => ({
  type: HOLD_ORDERS_SUCCESS,
  orderIds
});

export const holdOrdersFailed = (error) => ({
  type: HOLD_ORDERS_FAILED,
  error
});

export const unholdOrdersStart = () => ({
  type: UNHOLD_ORDERS_START
});

export const unholdOrdersSuccess = (orderIds) => ({
  type: UNHOLD_ORDERS_SUCCESS,
  orderIds
});

export const unholdOrdersFailed = (error) => ({
  type: UNHOLD_ORDERS_FAILED,
  error
});

export const updateMultipleOrdersPostedStatusStart = () => ({
  type: UPDATE_MULTIPLE_ORDERS_POSTED_STATUS_START
});

export const updateMultipleOrdersPostedStatusSuccess = (orders) => ({
  type: UPDATE_MULTIPLE_ORDERS_POSTED_STATUS_SUCCESS,
  orders
});

export const updateMultipleOrdersPostedStatusFailed = (error) => ({
  type: UPDATE_MULTIPLE_ORDERS_POSTED_STATUS_FAILED,
  error
});

export const generateOrdersInvoicePdfStart = () => ({
  type: GENERATE_ORDERS_INVOICE_PDF_START
});

export const generateOrdersInvoicePdfSuccess = (data) => ({
  type: GENERATE_ORDERS_INVOICE_PDF_SUCCESS,
  data
});

export const generateOrdersInvoicePdfFailed = (error) => ({
  type: GENERATE_ORDERS_INVOICE_PDF_FAILED,
  error
});

export const getStoreOrderItemsDetailsStart = () => ({
  type: GET_STORE_ORDER_ITEMS_DETAILS_START
});

export const getStoreOrderItemsDetailsSuccess = (data, entity_id) => ({
  type: GET_STORE_ORDER_ITEMS_DETAILS_SUCCESS,
  data,
  entity_id
});

export const getStoreOrderItemsDetailsFailed = (error) => ({
  type: GET_STORE_ORDER_ITEMS_DETAILS_FAILED,
  error
});

export const getInvoiceOrderDataStart = () => ({
  type: GET_INVOICE_ORDER_DATA_START
});

export const getInvoiceOrderDataSuccess = (data) => ({
  type: GET_INVOICE_ORDER_DATA_SUCCESS,
  data
});

export const getInvoiceOrderDataFailed = (error) => ({
  type: GET_INVOICE_ORDER_DATA_FAILED,
  error
});

export const getOrderProductsBySkusStart = () => ({
  type: GET_ORDER_PRODUCTS_BY_SKUS_START
});

export const getOrderProductsBySkusSuccess = (data) => ({
  type: GET_ORDER_PRODUCTS_BY_SKUS_SUCCESS,
  data
});

export const getOrderProductsBySkusFailed = (error) => ({
  type: GET_ORDER_PRODUCTS_BY_SKUS_FAILED,
  error
});

export const refundOrderStart = () => ({
  type: REFUND_ORDER_START
});

export const refundOrderSuccess = () => ({
  type: REFUND_ORDER_SUCCESS
});

export const refundOrderFailed = (error) => ({
  type: REFUND_ORDER_FAILED,
  error
});

export const shipOrderStart = () => ({
  type: SHIP_ORDER_START
});

export const shipOrderSuccess = (entityId, isOrderComplete, shipData) => ({
  type: SHIP_ORDER_SUCCESS,
  entityId,
  isOrderComplete,
  shipData
});

export const shipOrderFailed = (error) => ({
  type: SHIP_ORDER_FAILED,
  error
});

export const getNextechDuplicatedCustomersStart = () => ({
  type: GET_NEXTECH_DUPLICATED_CUSTOMERS_START
});

export const getNextechDuplicatedCustomersSuccess = (data) => ({
  type: GET_NEXTECH_DUPLICATED_CUSTOMERS_SUCCESS,
  data
});

export const getNextechDuplicatedCustomersFailed = (error) => ({
  type: GET_NEXTECH_DUPLICATED_CUSTOMERS_FAILED,
  error
});

export const getModmedDuplicatedCustomersStart = () => ({
  type: GET_MODMED_DUPLICATED_CUSTOMERS_START
});

export const getModmedDuplicatedCustomersSuccess = (data) => ({
  type: GET_MODMED_DUPLICATED_CUSTOMERS_SUCCESS,
  data
});

export const getModmedDuplicatedCustomersFailed = (error) => ({
  type: GET_MODMED_DUPLICATED_CUSTOMERS_FAILED,
  error
});

export const updateNextechStatusStart = () => ({
  type: UPDATE_NEXTECH_STATUS_START
});

export const updateNextechStatusSuccess = (data) => ({
  type: UPDATE_NEXTECH_STATUS_SUCCESS,
  data
});

export const updateNextechStatusFailed = (e) => ({
  type: UPDATE_NEXTECH_STATUS_FAILED,
  e
});

export const getInvoiceCommentsStart = () => ({
  type: GET_INVOICE_COMMENTS_START
});

export const getInvoiceCommentsSuccess = (data) => ({
  type: GET_INVOICE_COMMENTS_SUCCESS,
  data
});

export const getInvoiceCommentsFailed = (e) => ({
  type: GET_INVOICE_COMMENTS_FAILED,
  e
});

export const getShippingCommentsStart = () => ({
  type: GET_SHIPPING_COMMENTS_START
});

export const getShippingCommentsSuccess = (data) => ({
  type: GET_SHIPPING_COMMENTS_SUCCESS,
  data
});

export const getShippingCommentsFailed = (e) => ({
  type: GET_SHIPPING_COMMENTS_FAILED,
  e
});

export const getCreditMemoCommentsStart = () => ({
  type: GET_CREDIT_MEMO_COMMENTS_START
});

export const getCreditMemoCommentsSuccess = (data) => ({
  type: GET_CREDIT_MEMO_COMMENTS_SUCCESS,
  data
});

export const getCreditMemoCommentsFailed = (e) => ({
  type: GET_CREDIT_MEMO_COMMENTS_FAILED,
  e
});

export const getOrderShipmentsStart = () => ({
  type: GET_ORDERS_SHIPMENTS_START
});

export const getOrderShipmentsSuccess = (data, orderId) => ({
  type: GET_ORDERS_SHIPMENTS_SUCCESS,
  data,
  orderId
});

export const getOrderShipmentsFailed = (e) => ({
  type: GET_ORDERS_SHIPMENTS_FAILED,
  e
});

export const getPaymentMethodNameStart = () => ({
  type: GET_PEYMENT_METHOD_NAME_START
});

export const getPaymentMethodNameSuccess = (data) => ({
  type: GET_PEYMENT_METHOD_NAME_SUCCESS,
  data,
});

export const getPaymentMethodNameFailed = (error) => ({
  type: GET_PEYMENT_METHOD_NAME_FAILED,
  error
});
